import { get } from 'lodash';
import Schema from '../../../../../lib/paths/zuwendungsantrag_FULL_Paths.json';
import { groupKostenByPosition } from '../../../../../utils/helper';
import { cloneDeep } from 'lodash';
import { isArray } from 'lodash';
import { set } from 'lodash';
const P = Schema.attributes;

export const executeZuwendungsantragFormulas = (application: any, kostenKategories: any) => {
	let appCopy = cloneDeep(application);
	let result: any[] = [];

	const kostenKategoriesGroup = groupKostenByPosition(kostenKategories);

	let calcultedProjkJahr = calculateProjektStart(application);
	let calcultedProjkdauer = calculateProjektDauer(application);
	if (isArray(calcultedProjkJahr)) {
		for (let ele of calcultedProjkJahr) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	if (isArray(calcultedProjkdauer)) {
		for (let ele of calcultedProjkdauer) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calcultedProjkJahr);
	result.push(...calcultedProjkdauer);

	if (get(kostenKategoriesGroup, 'Ausgabe', []).length > 0) {
		let caculatedAusgaben = calculateAusgaben(appCopy);
		result.push(...caculatedAusgaben);
		for (let ele of caculatedAusgaben) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}

	if (get(kostenKategoriesGroup, 'Einnahme', []).length > 0) {
		let caculatedEinnahmen = calculateEinnahmen(appCopy);
		result.push(...caculatedEinnahmen);
		for (let ele of caculatedEinnahmen) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}

	let caculatedBeantragteFoerderung = calculateBeantragteFoerderung(appCopy);
	result.push(...caculatedBeantragteFoerderung);
	return result;
};

function calculateProjektStart(application: any) {
	const result = [];
	const projektStart = get(application, P.Allgemein_Geplanter_Durchfuehrungszeitraum_von.path, '');
	if (projektStart) {
		result.push({
			path: P.Allgemein_Projektstart_Jahr.path,
			value: new Date(projektStart).getFullYear(),
		});
	}
	return result;
}

function calculateProjektDauer(application: any) {
	const result = [];
	const projektStart = get(application, P.Allgemein_Geplanter_Durchfuehrungszeitraum_von.path, '');
	const projektEnd = get(application, P.Allgemein_Geplanter_Durchfuehrungszeitraum_bis.path, '');
	if (projektStart && projektEnd) {
		// Calculate the difference in milliseconds
		const diffInMs = new Date(projektEnd).getTime() - new Date(projektStart).getTime();

		// Convert the difference from milliseconds to years
		const millisecondsInYear = 1000 * 60 * 60 * 24 * 365.25; // considering leap years
		const diffInYears = diffInMs / millisecondsInYear;
		const roundedDiffInYears = Math.round(diffInYears);
		result.push({
			path: P.Allgemein_Projektdauerin_Jahren.path,
			value: roundedDiffInYears,
		});
	}
	return result;
}

function calculateAusgaben(application: any) {
	let result: any = [];
	const allAusgabenArr = get(application, P.Ausgaben.path, []);

	let gesamtAusgabe = 0;
	for (let i = 0; i < allAusgabenArr.length; i++) {
		const eachAusgaben = allAusgabenArr[i];
		let eachAusgabenSumme = 0.0;
		for (let ele of get(eachAusgaben, 'Ausgaben_Ausgaben_Block_1', [])) {
			eachAusgabenSumme += parseFloat(get(ele, 'Zelle_2', '0.0'));
		}
		gesamtAusgabe += eachAusgabenSumme;
		result.push({
			path: `${P.Ausgaben.path}.${i}.Zelle_2`,
			value: !isNaN(Number(eachAusgabenSumme)) ? eachAusgabenSumme.toFixed(2) : 0.0,
		});
	}
	result.push({
		path: `${P.Zusammenfassung_Gesamtausgaben_Geplant.path}`,
		value: !isNaN(gesamtAusgabe) ? gesamtAusgabe.toFixed(2) : 0.0,
	});

	return result;
}
function calculateEinnahmen(application: any) {
	let result: any = [];
	const allEinnahmenARR = get(application, P.Einnahmen.path, []);

	let gesamtEinnahme = 0;
	for (let i = 0; i < allEinnahmenARR.length; i++) {
		const eachEinnahmen = allEinnahmenARR[i];
		let eachEinnahmenSumme = 0;
		for (let ele of get(eachEinnahmen, 'Einnahmen_Einnahmen_Block_1', [])) {
			eachEinnahmenSumme += parseFloat(get(ele, 'Zelle_2', '0.0'));
		}
		gesamtEinnahme += eachEinnahmenSumme;
		result.push({
			path: `${P.Einnahmen.path}.${i}.Zelle_2`,
			value: !isNaN(eachEinnahmenSumme) ? eachEinnahmenSumme.toFixed(2) : 0.0,
		});
	}

	result.push({
		path: `${P.Zusammenfassung_Gesamteinnahmen_Geplant.path}`,
		value: !isNaN(gesamtEinnahme) ? gesamtEinnahme.toFixed(2) : 0.0,
	});

	return result;
}

function calculateBeantragteFoerderung(application: any) {
	let result: any = [];
	const gesamtAusgabe = get(application, P.Zusammenfassung_Gesamtausgaben_Geplant.path, 0);
	const gesamtEinnahme = get(application, P.Zusammenfassung_Gesamteinnahmen_Geplant.path, 0);
	const gesamtFoerderung = gesamtAusgabe > 0 ? gesamtAusgabe - gesamtEinnahme : 0;

	const foerderQuote = (gesamtFoerderung / gesamtAusgabe) * 100;

	result.push(
		{
			path: P.Zusammenfassung_Foerdersumme_Geplant.path,
			value: !isNaN(gesamtFoerderung) ? gesamtFoerderung.toFixed(2) : 0,
		},
		{
			path: P.Zusammenfassung_Foerderquote_Geplant.path,
			value: !isNaN(foerderQuote) ? foerderQuote.toFixed(2) : 0,
		},
	);

	return result;
}
